export default __webpack_public_path__ + "static/media/02.abff4bc0.jpg";